export enum EHlasovaciPrava {
    S = 'S',
    B = 'B',
    O = 'O',
    Z = 'Z'
}
